import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Platform-specific: register via provideUserCentrics() (browser) or provideUserCentricsServer() (SSR). */
@Injectable({
    providedIn: 'root',
    useFactory: (): never => {
        throw new Error(
            'No implementation for UserCentricsService. Add provideUserCentrics() or provideUserCentricsServer() to your app config.',
        );
    },
})
export abstract class UserCentricsService {
    public readonly isLoaded = new BehaviorSubject<boolean>(false);

    public abstract set redirectUrl(url: string);
    public abstract get redirectUrl(): string | null;

    public abstract hasUserCurrentlyConsented(serviceName: string): Promise<boolean>;
    public abstract hasUserConsented(serviceName: string): BehaviorSubject<boolean>;
    public abstract showSecondLayer(): void;
    public abstract acceptConsent(serviceName: string): Promise<void>;
}
